import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import api, {standardApiSlice} from 'service/api'

export const submitContactForm = createAsyncThunk('contact/submit', api.post('/contact'))

export const contactSlice = createSlice(standardApiSlice('contact', submitContactForm))

export const { clearErrors } = contactSlice.actions

export default contactSlice.reducer